import { useState, useEffect, useCallback } from "react";
import { fetchAssistants } from "../api/api";

export function useAssistants(userId) {
  const [assistants, setAssistants] = useState([]);
  const [currentAssistant, setCurrentAssistant] = useState(null);
  const [assistantName, setAssistantName] = useState("");
  const [hints, setHints] = useState([]);

  useEffect(() => {
    if (!userId) return;
    let ignore = false;
    (async () => {
      try {
        const data = await fetchAssistants(userId);
        if (ignore) return;
        setAssistants(data);
        if (data.length) {
          setCurrentAssistant(data[0].assistantId);
          setAssistantName(data[0].name);
        }
      } catch (err) {
        console.error("fetchAssistants:", err);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [userId]);

  useEffect(() => {
    if (!currentAssistant) return;
    (async () => {
      try {
        const res = await fetch(`/assistants/${currentAssistant}/hints`);
        if (!res.ok) throw new Error(res.statusText);
        const data = (await res.json()) ?? [];
        setHints(data.slice(0, 3));
      } catch (e) {
        console.error("fetch hints:", e);
        setHints([]);
      }
    })();
  }, [currentAssistant]);

  const chooseAssistant = useCallback((asst) => {
    setCurrentAssistant(asst.assistantId);
    setAssistantName(asst.name);
  }, []);

  return {
    assistants,
    currentAssistant,
    assistantName,
    hints,
    chooseAssistant,
  };
}